"use client";
import Image from "next/image";
import {ChevronRight} from "lucide-react";
import {useRouter} from "next/navigation";
import {getLogoBrand} from "@/utils/getLogoBrand";
import { canOptimizeImageSource } from "@/lib/image-source";

export interface Offer {
    id: string;
    title: string;
    description: string;
    price: string;
    image: string;
    rate: string;
    slug: any;
    brand?: string;
    model?: string;
    brandCode?: string;
}

export default function CardOffer(offer: Offer) {
    const router = useRouter();
    const brandLogo = getLogoBrand(offer.brandCode || offer.brand || "");
    const canOptimizeOfferImage = canOptimizeImageSource(offer.image);

    return (
        <div
            className="relative rounded-2xl overflow-hidden shadow-xl aspect-[340/530] flex flex-col justify-between bg-[#0B2BA7]"
            style={{
                backgroundImage: "url(/assets/last-minute-bg.webp)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            {/* Parte superiore: prezzo e info */}
            <div className="pt-6 text-center relative z-10">
                <h3 className="text-lg font-bold text-white/80 tracking-wide">TUA A</h3>
                <p className="text-6xl font-extrabold text-white  leading-tight">
                    {parseFloat(offer.price).toLocaleString('it-IT')} €
                </p>
                <p className="text-sm text-white/90 mt-1">Da <strong>{parseFloat(offer.rate).toLocaleString('it-IT')}€</strong> al mese</p>
{/*
                <p className="text-sm text-white/70">Anticipo 2000€</p>
*/}

                {/* <div className="inline-block mt-3 bg-[#D20000] text-white text-xs font-bold uppercase px-4 py-1 rounded-full">
                    Km 0
                </div>*/}
            </div>

            {/* Auto */}
            <div className="relative z-10 w-full flex justify-center mt-4">
                {canOptimizeOfferImage ? (
                    <Image
                        src={offer.image}
                        alt={offer.title}
                        width={640}
                        height={360}
                        sizes="(max-width: 640px) 86vw, (max-width: 1024px) 42vw, 360px"
                        className="w-full h-[240px] object-contain drop-shadow-[0_8px_20px_rgba(0,0,0,0.5)]"
                        loading="lazy"
                    />
                ) : (
                    <img
                        src={offer.image}
                        alt={offer.title}
                        className="w-full h-[240px] object-contain drop-shadow-[0_8px_20px_rgba(0,0,0,0.5)]"
                        loading="lazy"
                        decoding="async"
                    />
                )}
            </div>

            {/* Parte inferiore: modello e pulsante */}
            <div className="relative z-10 text-center pb-6">
                <div className="flex justify-center mb-2">
                    <Image
                        src={brandLogo}
                        alt={`Logo ${offer.brand || offer.title}`}
                        width={140}
                        height={50}
                        sizes="140px"
                        className="h-[50px] w-auto object-contain"
                    />
                </div>
                <h4 className="text-white text-2xl font-bold leading-tight">{offer.brand || offer.title}</h4>
                <p className="text-white/80 text-sm mb-4">{offer.model || offer.description}</p>

                <button
                    onClick={() => {
                        offer.slug && router.push(`/offerta-last-minute/${offer.slug.current}`);
                    }}
                    className="mx-auto flex items-center justify-center gap-2 bg-white border-2 border-white hover:text-white text-[#001A72] font-semibold px-6 py-2 rounded-md shadow-md hover:bg-transparent transition-all"
                >
                    Blocca il prezzo
                    <ChevronRight strokeWidth={1.5}/>
                </button>
            </div>
        </div>

    );

}
